import './Complete.scss';
import Component from './Complete.js';
export default Component;
